import * as Constants from '../constants';

const initialState = {
  orderID: '',
  orderDetails: {},
  loading: false,
  error: {},
  physicalReport: false,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.PLACE_DIAGNOSTICS_ORDER_START:
      return Object.assign({}, state, { loading: true });
    case Constants.PLACE_DIAGNOSTICS_ORDER_SUCCESS:
      return Object.assign({}, state, { orderID: action.data.order_id, loading: false });
    case Constants.PLACE_DIAGNOSTICS_ORDER_FAILURE:
      return Object.assign({}, state, { error: action.data.error, loading: false });
    case Constants.GET_DIAGNOSTICS_ORDER_DETAILS_START:
      return Object.assign({}, state, { loading: true });
    case Constants.GET_DIAGNOSTICS_ORDER_DETAILS_SUCCESS:
      return Object.assign({}, state, { orderDetails: action.data.order_summary, loading: false });
    case Constants.GET_DIAGNOSTICS_ORDER_DETAILS_FAILURE:
      return Object.assign({}, state, { error: action.data.error, loading: false });
    case Constants.SET_PHYSICAL_REPORT_NEEDED:
      return Object.assign({}, state, { physicalReport: action.data });
    default:
      return { ...state };
  }
}
